export default __webpack_public_path__ + "static/media/rewards_icon_services.764c43bf.svg";